<template>
  <v-form>
    <v-card width="400" height="400" align="center" class="cardForgot">
      <v-card-title primary-title class="title">
        {{ $t("forgotPassword.title") }}
      </v-card-title>

      <v-card-text>
        {{ $t("forgotPassword.forgotPasswordText") }}
      </v-card-text>

      <v-card-actions class="justify-center cardActionForgot">
        <v-btn color="primary" :to="'/'">
          {{ $t("forgotPassword.goBack") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cardForgot {
  padding: 2rem 2rem;
}

.cardActionForgot {
  padding: 1rem;
}

.title {
  font-size: 1.5rem !important;
  justify-content: center;
}
</style>
